

document.addEventListener("DOMContentLoaded", function() {
  const wishlistIcon = document.getElementById('wishlist-icon');
  let wishlistItems = JSON.parse(localStorage.getItem('wishlist')) || [];
  const wishlistCountBadge = document.querySelector('.wishlist-count');
  const wishlistItemsContainer = document.getElementById('wishlist-items'); // Container for wishlist items in the DOM

  // Function to update wishlist icon count
  function updateWishlistIcon() {
    const count = wishlistItems.length;
    wishlistIcon.setAttribute('data-count', count);

    if (count > 0) {
      wishlistCountBadge.textContent = count;
      wishlistCountBadge.style.display = 'inline-block';
    } else {
      wishlistCountBadge.style.display = 'none';
    }
  }

  // Function to toggle the button's active state (heart icon and text)
  function toggleWishlistButtonState(button, productId) {
    if (wishlistItems.some(item => item.id === productId)) {
      button.classList.add('active'); // Show as "saved"
      button.querySelector('.wishlist-text').textContent = 'Saved to Wishlist'; // Update text to "Saved"
      button.querySelector('.wishlist-icon').textContent = '❤️'; // Change heart color to red
    } else {
      button.classList.remove('active'); // Show as "not saved"
      button.querySelector('.wishlist-text').textContent = 'Add to Wishlist'; // Reset text to "Add"
      button.querySelector('.wishlist-icon').textContent = '🤍'; // Change heart color to white
    }
  }

  // Add item to wishlist
  function addToWishlist(productId, productTitle, productUrl, productImage) {
    const item = {
      id: productId,
      title: productTitle,
      url: productUrl,
      image: productImage
    };

    // Prevent duplicates
    if (!wishlistItems.some(existingItem => existingItem.id === item.id)) {
      wishlistItems.push(item);
      localStorage.setItem('wishlist', JSON.stringify(wishlistItems));
      updateWishlistIcon();
      updateWishlistMetafield(wishlistItems); // Update metafield with new wishlist
    }
  }

  // Remove item from wishlist
  function removeFromWishlist(productId) {
    wishlistItems = wishlistItems.filter(item => item.id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlistItems));
    updateWishlistIcon();
    displayWishlistItems(); // Update the wishlist display without page reload
    updateWishlistMetafield(wishlistItems); // Update metafield after removal
  }

  // Function to render wishlist items
  function displayWishlistItems() {
    wishlistItemsContainer.innerHTML = ''; // Clear existing wishlist items
    if (wishlistItems.length === 0) {
      wishlistItemsContainer.innerHTML = '<p>Your wishlist is empty. Start adding products!</p>';
    } else {
      wishlistItems.forEach(item => {
        const listItem = document.createElement('li');
        listItem.classList.add('wishlist-item');
        listItem.innerHTML = `
          <a href="${item.url}">
            <img src="${item.image}" alt="${item.title}" width="100" height="100"/>
            <p>${item.title}</p>
          </a>
          <button class="remove-from-wishlist" data-id="${item.id}">Remove</button>
        `;
        wishlistItemsContainer.appendChild(listItem);
      });

      // Bind the remove button click events after items are rendered
      document.querySelectorAll('.remove-from-wishlist').forEach(button => {
        button.addEventListener('click', function() {
          const productId = this.getAttribute('data-id');
          removeFromWishlist(productId); // Remove the item
        });
      });
    }
  }

  // Update the wishlist metafield using Shopify AJAX API
  function updateWishlistMetafield(wishlistItems) {
    fetch('/wishlist/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        wishlist: wishlistItems
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Wishlist updated successfully:', data);
      // Optionally refresh or update the UI
    })
    .catch(error => console.error('Error updating wishlist metafield:', error));
  }

  // Bind add/remove to wishlist button with toggle functionality
  document.querySelectorAll('.add-to-wishlist').forEach(button => {
    const productId = button.getAttribute('data-product-id');
    
    // Initialize the button state based on the current wishlist
    toggleWishlistButtonState(button, productId);

    button.addEventListener('click', function() {
      const productTitle = this.getAttribute('data-product-title');
      const productUrl = this.getAttribute('data-product-url');
      const productImage = this.getAttribute('data-product-image');
      
      if (wishlistItems.some(item => item.id === productId)) {
        // Item is already in the wishlist, so remove it
        removeFromWishlist(productId);
        toggleWishlistButtonState(button, productId); // Update button state
      } else {
        // Item is not in the wishlist, so add it
        addToWishlist(productId, productTitle, productUrl, productImage);
        toggleWishlistButtonState(button, productId); // Update button state
      }
    });
  });

  // Initialize the wishlist icon and display the wishlist items
  updateWishlistIcon();
  displayWishlistItems();
});
